import { render, staticRenderFns } from "./checkout-payment.vue?vue&type=template&id=42f89ab1&"
import script from "./checkout-payment.vue?vue&type=script&lang=js&"
export * from "./checkout-payment.vue?vue&type=script&lang=js&"
import style0 from "./checkout-payment.vue?vue&type=style&index=0&id=42f89ab1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports